import { render } from "./TrialTime.vue?vue&type=template&id=3aa73582&ts=true"
import script from "./TrialTime.vue?vue&type=script&lang=ts"
export * from "./TrialTime.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__